import React from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { hoursToMinutes, minutesToHours } from '../../../../utils/time';

const DurationFormat: React.FC<
  React.PropsWithChildren<{ minutes: number }>
> = ({ minutes }) => {
  const { t } = useTranslation();
  const formatDuration = formattedDuration(t);

  return <>{formatDuration(minutes)}</>;
};

// Please keep in sync with salesforce timeUtils.js
export const formattedDuration = (t: TFunction) => (timeInMinutes: number) => {
  const isNegative = timeInMinutes < 0;
  const minutesAbs = Math.abs(timeInMinutes);
  const hours = Math.floor(minutesToHours(minutesAbs));
  const minutes = Math.round(minutesAbs - hoursToMinutes(hours));

  const format = (result: string) => `${isNegative ? '-' : ''}${result}`;

  if (hours > 0 && minutes === 0) {
    return format(t('durationFormat.hours', { hours }));
  }

  if (hours === 0) {
    return format(t('durationFormat.minutes', { minutes }));
  }

  return format(t('durationFormat.full', { hours, minutes }));
};

export default DurationFormat;
